<h1>
  Elegí el horario de cabecera
  <span *ngIf="groups.length > 1">
    para cada día
  </span>
</h1>

<div class="time-group" *ngFor="let group of groups">

  <div class="time-group-header">
    {{ group.dateKey | date:'dd/MM/yyyy' }}
  </div>

  <div class="time-grid">

    <div class="time-card"
         *ngFor="let trip of group.trips"
         (click)="group.selected = trip"
         [class.active]="group.selected?.id === trip.id">

      <div class="time-hour">
        {{ trip.date | date: 'HH:mm' }}
      </div>

      <div class="time-label" *ngIf="trip.name">
        {{ trip.name }}
      </div>

      <div class="time-check" *ngIf="group.selected?.id === trip.id">
        ✓
      </div>

    </div>

  </div>

</div>

<button class="btn btn-success btn-block btn-lg"
        (click)="ok()">
  Continuar
</button>